import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const ltTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Vardas (mažosiomis raidėmis, be specialių simbolių)',
    add: 'Pridėti',
    allowedFileTypes: 'Leidžiami failų tipai',
    allowedFileTypesDescription:
      'Apriboti leidžiamus failų tipus (pvz., vaizdas/*, programa/pdf). Palikite tuščią, kad leistumėte visus tipus.',
    allowMultipleFiles: 'Leisti kelis failus',
    amountInCents: 'Suma centais',
    basePrice: 'Bazinė kaina',
    bcc: 'BCC',
    brand: 'Prekės ženklas',
    cc: 'CC',
    checkboxPlural: 'Žymės laukeliai Laukai',
    checkboxSingular: 'Žymimasis laukelis',
    checkedByDefault: 'Patikrinta pagal numatytuosius nustatymus',
    chooseConfirmationType:
      'Pasirinkite, ar pateikti puslapyje pranešimą, ar peradresuoti į kitą puslapį po to, kai jie pateikia formą.',
    condition: 'Būklė',
    confirmationMessage: 'Patvirtinimo žinutė',
    confirmationType: 'Patvirtinimo tipas',
    countryPlural: 'Šalies laukai',
    countrySingular: 'Šalis',
    creditCard: 'Kreditinė kortelė',
    customURL: 'Tinkintas URL',
    datePlural: 'Datos laukai',
    dateSingular: 'Data',
    defaultValue: 'Numatytoji reikšmė',
    divide: 'Padalinti',
    documentToLinkTo: 'Dokumentas, į kurį reikia susieti',
    doesNotEqual: 'Nelygu',
    emailFrom: 'El. paštas nuo',
    emailPlural: 'El. pašto laukai',
    emailsDescription:
      'Siųskite pasirinktinius el. laiškus, kai forma bus pateikta. Norėdami išsiųsti tą patį el. laišką keliems gavėjams, naudokite kableliais atskirtus sąrašus. Norėdami nurodyti reikšmę iš šios formos, įrašykite to lauko pavadinimą dvigubais riestiniais skliaustais, t. y. {{firstName}}. Galite naudoti pakaitos simbolį {{*}}, kad išvestumėte visus duomenis, ir {{*:table}}, kad formatuotumėte juos kaip HTML lentelę el.',
    emailSingular: 'El. paštas',
    emailTo: 'El. paštu',
    equals: 'Lygu',
    field: 'Laukas',
    fields: 'Laukai',
    fieldWidth: 'Lauko plotis (procentais)',
    hasAnyValue: 'Turi bet kokią vertę',
    internalLink: 'Vidinė nuoroda',
    label: 'Etiketė',
    maxFileSize: 'Maksimalus failo dydis (baitais)',
    maxFileSizeDescription: 'Didžiausias failo dydis baitais. Palikite tuščią be jokių apribojimų.',
    message: 'Pranešimas',
    messageDescription: 'Įveskite pranešimą, kuris turėtų būti išsiųstas šiame el. laiške.',
    messagePlural: 'Pranešimų blokai',
    messageSingular: 'Pranešimas',
    mimeType: 'MIME tipas',
    mimeTypePlural: 'MIME tipai',
    mimeTypeSingular: 'MIME tipas',
    multiply: 'Padauginti',
    numberPlural: 'Skaičių laukai',
    numberSingular: 'Skaičius',
    optionPlural: 'Parinktys',
    optionSingular: 'Parinktis',
    paymentFieldPlural: 'Mokėjimo laukai',
    paymentFieldSingular: 'Mokėjimas',
    paymentProcessor: 'Mokėjimo procesorius',
    paymentStatus: 'Būsena',
    placeholder: 'Vietos rezervuaras',
    priceConditions: 'Kainos sąlygos',
    priceConditionsPlural: 'Kainos sąlygos',
    priceConditionsSingular: 'Kainos būklė',
    radioOptions: 'Radijo atributų parinktys',
    radioPlural: 'Radijo laukai',
    radioSingular: 'Radijas',
    redirect: 'Peradresuoti',
    replyTo: 'Atsakyti į',
    required: 'Privaloma',
    selectOptions: 'Pasirinkite Parinktys',
    selectPlural: 'Pasirinkite Laukai',
    selectSingular: 'Pasirinkite',
    statePlural: 'Valstybės laukai',
    stateSingular: 'valstybė',
    staticValue: 'Statinė vertė',
    subject: 'Tema',
    submitButton: 'Pateikti mygtuko etiketę',
    subtract: 'Atimti',
    textareaPlural: 'Textarea laukai',
    textareaSingular: 'Textarea',
    textPlural: 'Teksto laukai',
    textSingular: 'Tekstas',
    title: 'Pavadinimas',
    token: 'žetonas',
    uploadCollection: 'Įkelti kolekciją',
    uploadCollectionDescription: 'Pasirinkite, kurioje įkėlimo kolekcijoje norite saugoti failus',
    uploadFieldPlural: 'Įkelkite laukus',
    uploadFieldSingular: 'Įkelti',
    urlToRedirectTo: 'URL, į kurį reikia peradresuoti',
    value: 'Vertė',
    valueOfField: 'Lauko vertė',
    valueType: 'Vertės tipas',
  },
}

export const lt: PluginLanguage = {
  dateFNSKey: 'lt',
  translations: ltTranslations,
}
